import React, { useState, useEffect } from "react";
import moment from "moment/moment";
import { useFetchQueTypes, useFetchAudCycles } from "../../../../utils/hooks/UseFetchUrl";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const ARActions = ({ actionRepData, primaryColor }) => {
  const { data: queTypesData } = useFetchQueTypes("/questionnaire_types_for_dashboard");
  const { data: cyclesData } = useFetchAudCycles("/audit_cycle_for_dashboard");

  const queId = queTypesData?.[0]?.id;
  const [cycleId, setCycleId] = useState(null);
  const [selectedQueId, setSelectedQueId] = useState(null);
  const [detailsData, setDetailsData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [tabData, setTabData] = useState([]);
  const [isAuditDetailsOpen, setIsAuditDetailsOpen] = useState(true);

  useEffect(() => {
    if (actionRepData) {
      setTabData(actionRepData);
    }
  }, [actionRepData]);

  useEffect(() => {
    if (cyclesData && selectedQueId) {
      const filteredCycles = cyclesData.filter(
        (cycle) => cycle.questionnaire_type.id === selectedQueId,
      );
      setDetailsData(filteredCycles);
      if (filteredCycles.length > 0) {
        setCycleId(filteredCycles[0].id);
      } else {
        setCycleId(null);
      }
    }
  }, [cyclesData, selectedQueId]);

  useEffect(() => {
    if (queId) {
      setSelectedQueId(queId);
    }
  }, [queId]);

  const filteredData = tabData.filter((item) => {
    if (statusFilter === "ALL") return true;
    return item.status === statusFilter;
  });

  return (
    filteredData.length > 0 && (
      <div className="card">
        <div
          className="card-header"
          onClick={() => setIsAuditDetailsOpen((prev) => !prev)}
           style={{
            backgroundColor: primaryColor || undefined,
            color: primaryColor ? "#fff" : undefined,
          }}
        >
          <p>Report Actions</p>
          {!isAuditDetailsOpen ? <UpOutlined /> : <DownOutlined />}
        </div>
        {isAuditDetailsOpen && (
        <div className="heroSection p-2">
          <div className="dashTable table-responsive">
            <table id="table-to-export">
              <thead>
                <tr className="report-head">
                  <th style={{ width: "185px" }} className="text-center">
                    Person Responsible
                  </th>
                  <th style={{ width: "150px" }} className="text-center">
                    Target Date
                  </th>
                  <th style={{ width: "131px" }} className="text-center">
                    Store
                  </th>
                  <th style={{ width: "84px" }}>Created By</th>
                  <th style={{ width: "267px" }} className="text-center">
                    Action Plan
                  </th>
                  <th style={{ width: "130px" }} className="text-center">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <tr key={row.id}>
                      <td className="text-left personRA">
                        {row.person_responsible}
                      </td>
                      <td className="text-center tDateRA">
                        {moment(row.target_date).format("Do MMM YYYY")}
                      </td>
                      <td className="text-left storeRA">{row.store_details}</td>
                      <td className="text-center createdByRA">
                        {row.created_by}
                      </td>
                      <td className="action-planTxt">
                        {row.action_plan_description}
                      </td>
                      <td className="statusRA">
                        <div className="pendingTd d-flex justify-content-center align-items-center">
                          <div
                            className={`status ${
                              row.status === "TAKEN" ? "taken" : "pending"
                            } d-flex align-items-center justify-content-center`}
                            style={{
                              backgroundColor:
                                row.status === "TAKEN" ? "#E9FFEF" : "#FFF2DD",
                              borderRadius: "10px",
                              width: "135px",
                              height: "30px",
                            }}
                          >
                            <i
                              style={{
                                fontSize: "2.2rem",
                                margin: "0",
                                color:
                                  row.status === "TAKEN"
                                    ? "#409261"
                                    : "#D98634",
                              }}
                              className="bi bi-dot"
                            ></i>
                            <p
                              className="my-2"
                              style={{
                                fontWeight: "400",
                                fontSize: "13px",
                                lineHeight: "14px",
                                color:
                                  row.status === "TAKEN"
                                    ? "#409261"
                                    : "#D98634",
                              }}
                            >
                              {row.status === "TAKEN"
                                ? "Action Taken"
                                : "Action Pending"}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="no-data-section py-3">
                      No Data Available for this Report
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        )}
      </div>
    )
  );
};

export default ARActions;
